import(/* webpackMode: "eager", webpackExports: ["LegalEntry"] */ "/app/apps/web/src/components/legal/legal-entry.tsx");
